import React, { Component } from 'react';

class ThanksPage extends Component {

  render() {
    return (
      <div style={{padding: 20}}>
        <h1>Contact Us</h1>

        <p>Thanks, we'll get back to you as soon as possible.</p>
      </div>
    );
  }
}

export default ThanksPage;




/** WEBPACK FOOTER **
 ** ./src/ThanksPage.js
 **/